import { toast } from 'react-toastify';
import {
  SUPER_ADMIN_LOAD_REPORT,
  SUPER_ADMIN_RENDER_REPORT,
  SUPER_ADMIN_LOAD_REPORT_FAILED,
  SUPER_ADMIN_LOAD_STRESS_REPORT,
  SUPER_ADMIN_RENDER_STRESS_REPORT,
  SUPER_ADMIN_LOAD_REPORT_STRESS_FAILED,
} from '../actions/SuperAdminReportsActions';

import { SIGNED_OUT } from '../actions/index';

const initialState = {
  currentPage: 1,
  totalPage: 1,
  total: 0,

  allPhpVersion: [],
  allWpInsVersion: [],
  allWordpressVersion: [],
  allProducts: [],
  allUsers: [],
  siteList: [],
  wpVersion: [],
  phpVersion: [],
  pluginVersion: [],
  status: [],
  language: [],
  de_active_reasons: [],
  activeSitesCount: 0,
  deactivedSitesCount: 0,
  totalUserCount: 0,
  newUserCount: 0,
  analytics: [],
  mailchimpAnalytics: [],
  sitesConfig: [],
  sortedBy: [],
  reportLoader: false,

  allProductsForStress: [],
  stressReportLoader: false,
  successAnalytics: [],
  errorAnalytics: [],
};

export default function report(state = initialState, action) {
  switch (action.type) {
    case SUPER_ADMIN_LOAD_REPORT:
      return {
        ...state,
        reportLoader: true,
      };
    case SUPER_ADMIN_LOAD_STRESS_REPORT:
      return {
        ...state,
        stressReportLoader: true,
      };

    case SUPER_ADMIN_RENDER_STRESS_REPORT:
      return {
        ...state,
        allProductsForStress: action.allProductsForStress,
        successAnalytics: action.successAnalytics,
        errorAnalytics: action.errorAnalytics,
        stressReportLoader: false,
      };

    case SUPER_ADMIN_RENDER_REPORT:
      return {
        ...state,
        sitesConfig: action.sitesConfig,
        sortedBy: action.sortedBy,
        reportLoader: false,
        siteList: action.siteList,

        currentPage: action.currentPage
          ? action.currentPage
          : state.currentPage,
        totalPage: action.totalPage ? action.totalPage : state.totalPage,
        total: action.total ? action.total : state.total,

        allPhpVersion: action.allPhpVersion
          ? action.allPhpVersion
          : state.allPhpVersion,
        allWpInsVersion: action.allWpInsVersion
          ? action.allWpInsVersion
          : state.allWpInsVersion,
        allWordpressVersion: action.allWordpressVersion
          ? action.allWordpressVersion
          : state.allWordpressVersion,
        allProducts: action.allProducts
          ? action.allProducts
          : state.allProducts,
        allUsers: action.allUsers ? action.allUsers : state.allUsers,

        wpVersion: action.wpVersion ? action.wpVersion : state.wpVersion,
        phpVersion: action.phpVersion ? action.phpVersion : state.phpVersion,
        pluginVersion: action.pluginVersion
          ? action.pluginVersion
          : state.pluginVersion,
        status: action.status ? action.status : state.status,
        language: action.language ? action.language : state.language,
        de_active_reasons: action.de_active_reasons
          ? action.de_active_reasons
          : state.de_active_reasons,
        activeSitesCount: action.activeSitesCount
          ? action.activeSitesCount
          : state.activeSitesCount,
        deactivedSitesCount: action.deactivedSitesCount
          ? action.deactivedSitesCount
          : state.deactivedSitesCount,
        analytics: action.analytics ? action.analytics : state.analytics,
        mailchimpAnalytics: action.mailchimpAnalytics
          ? action.mailchimpAnalytics
          : state.mailchimpAnalytics,

        totalUserCount: action.totalUserCount
          ? action.totalUserCount
          : state.totalUserCount,
        newUserCount: action.newUserCount
          ? action.newUserCount
          : state.newUserCount,
      };

    case SUPER_ADMIN_LOAD_REPORT_FAILED:
      toast.error(action.message);
      return {
        ...state,
        reportLoader: false,
      };
    case SUPER_ADMIN_LOAD_REPORT_STRESS_FAILED:
      toast.error(action.message);
      return {
        ...state,
        stressReportLoader: false,
      };
    case SIGNED_OUT:
      return { ...initialState };
    default:
      return state;
  }
}
